module.exports = __webpack_public_path__ + "assets/img/service-module2-8.e479dfc7.png";